import { FeatureFlag, useFeatureFlag } from '../Contexts/FeatureFlagContext';
export function useCryptolessMode() {
    return useFeatureFlag(FeatureFlag.ENABLE_CRYPTOLESS_MODE);
}
